import { createContext, Dispatch } from "react";

import type { PropertiesTabConfig } from "components/window/core/properties/types";

export interface PropertiesTabEntry {
    config: PropertiesTabConfig;
    /** Additional state that is tab-specific can be added here */
    // For example: tab disabled state, etc.
}

export interface PropertiesTabsState {
    tabEntries: Record<string, PropertiesTabEntry>;
    /** Additional state that is not tab-specific can be added here */
}

export const initialState: PropertiesTabsState = {
    tabEntries: {},
};

export type State = typeof initialState;

enum ActionTypes {
    AddTab,
    RemoveTab,
}

function addTab(tabEntry: PropertiesTabEntry) {
    return {
        type: ActionTypes.AddTab as const,
        tabEntry,
    };
}

function removeTab(tabId: string) {
    return {
        type: ActionTypes.RemoveTab as const,
        tabId,
    };
}

export const actions = { addTab, removeTab };

type Actions = ReturnType<(typeof actions)[keyof typeof actions]>;
export type DispatchPropertiesTabs = Dispatch<Actions>;
export const StateContext = createContext<State>(initialState);
export const DispatchContext = createContext<DispatchPropertiesTabs | undefined>(undefined);

export function reducer(state: State, action: Actions): State {
    switch (action.type) {
        case ActionTypes.AddTab: {
            const tabId = action.tabEntry.config.id;

            if (state.tabEntries[tabId]) {
                return state;
            }

            return {
                ...state,
                tabEntries: {
                    ...state.tabEntries,
                    [tabId]: action.tabEntry,
                },
            };
        }
        case ActionTypes.RemoveTab: {
            const { [action.tabId]: _removed, ...remainingTabEntries } = state.tabEntries;
            return {
                ...state,
                tabEntries: remainingTabEntries,
            };
        }
        default: {
            throw new Error(`Unhandled action type`);
        }
    }
}
